import * as XLSX from "xlsx";

// Download buttons of the Dashboard / Your Stats charts: the rows the chart
// shows, saved client-side as Excel (like State Wise and Live Ranking).
// `header` fixes the column order — json_to_sheet would otherwise put
// number-like keys ("2024") first.
export function saveChartSheet(rows, header, sheetName, filePrefix) {
  if (!rows || rows.length === 0) return;
  const sheet = XLSX.utils.json_to_sheet(rows, { header });
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, sheetName);
  XLSX.writeFile(book, `${filePrefix}-${new Date().toISOString().slice(0, 10)}.xlsx`);
}

// Book Wise: one row per book, one column per year shown.
export function downloadBookWise(data, series) {
  const years = (series || []).map((item) => item.name);
  const rows = (data || []).map((row) => {
    const out = { Book: row.name };
    (series || []).forEach((item) => {
      out[item.name] = Number(row[item.key]) || 0;
    });
    return out;
  });
  saveChartSheet(rows, ["Book", ...years], "Book Wise", "Book-Wise-Distribution");
}

// Year Wise: one row per year.
export function downloadYearWise(data) {
  const rows = (data || []).map((row) => ({ Year: row.name, "Books Distributed": Number(row.quantity) || 0 }));
  saveChartSheet(rows, ["Year", "Books Distributed"], "Year Wise", "Year-Wise-Book-Distribution");
}
